<template>
    <div class="mapp__container container">
        <div class="mapp__container-texto">
            <h3 class="mapp__container-titulo" v-html="$t('all.banner_mapa.titulo', {msg: $root.pais_actual})"></h3>
            <p class="mapp__container-parrafo">
                {{ $t('all.banner_mapa.texto', {msg: $root.nombre_estado}) }}
            </p>
        </div>
        <div class="row mapp__container-contenedor rounded-container">
            <div class="mapp__container-checklist rounded-container col-12 col-md-3" v-if="!$root.is_mobile"> 
                <grafico-checklist ref="checklist_mapa" />  
            </div>
            <!-- movil  -->
            <div class="mapp__container-listadofilter w-100" v-else> 
                <FilterDropDowns ref="checklist_mapa" v-on:changeTreemap="changeTreemap" /> 
            </div>
            <div class="mapp__container-mapa rounded-container col-12 col-md-5"> 
                <grafico-mapa ref="mapa" /> 
            </div>
            <div class="mapp__container-treemap rounded-container col-12 col-md-4" v-if="!$root.is_mobile"> 
                <grafico-treemap v-on:changeTreemap="changeTreemap" ref="treemap" /> 
            </div>
            <!-- movil  -->
            <div class="mapp__container-listadoacti rounded-container col-12 px-0 px-md-3" v-else> 
                <ListadoActividadesEconomicas v-on:changeTreemap="changeTreemap" ref="treemap_movil" /> 
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
import { store, mutations } from '../../store/store';

export default {
    name: 'BannerMapa',
    components: {
        GraficoChecklist: resolve => require(['./GraficoChecklist'], resolve),
        GraficoMapa: resolve => require(['@/components/map/MapSelection'], resolve),
        GraficoTreemap: resolve => require(['./GraficoTreemap'], resolve),
        ListadoActividadesEconomicas: resolve => require(['./movil/ListadoActividadesEconomicas'], resolve),
        FilterDropDowns: resolve => require(['./movil/FilterDropDowns'], resolve),
    },
    data: () => ({
        sumaProcesos: 0,
        sumaDinero: 0,
        requests: {
            infoCheckListRequest: null,
            infoDeptosRequest: null,
            filterRequest: null,
        },
        copyCurrentDataDeptos: [],
        nombre_estado: '',
    }),
    created() {
        this.initializeComponent();
    },
    methods: {
        /**
         * Inicializador del componente
         * 
         * @author Óscar
         */
        initializeComponent () {
            this.makeHttpRequests();
            this.requestFilteredData();
        },
        /**
         * Ejecutor de requests necesarios para la inicialización
         * 
         * @author Óscar
         */
        makeHttpRequests () {
            this.getMainInformation();
        },
        /**
         * Obtiene mediantes http la data principal para el checklist, mapa y treemap
         * 
         * @author Óscar
         */
        async getMainInformation() {
            try {
                this.$root.cargando();

                const infoChecklistURI = `${this.$root.raiz_virtual}/informacion-mapa`;
                const deptosURI = `${this.$root.raiz_virtual}/interactive-map/getDepartamentos`;

                if (this.requests.infoCheckListRequest || this.requests.infoDeptosRequest) {
                    this.cancelMainInformationRequests();
                }

                const axiosSource = axios.CancelToken.source();
                const cancelToken = axiosSource.token;
                
                this.requests.infoCheckListRequest = { cancel: axiosSource.cancel };
                this.requests.infoDeptosRequest = { cancel: axiosSource.cancel }

                const requestPromiseInfoChecklist = axios.get(infoChecklistURI, { cancelToken });
                const requestPromiseDeptos = axios.get(deptosURI, { cancelToken });

                const response = await Promise.all([ requestPromiseInfoChecklist, requestPromiseDeptos ]);

                this.handleServerResponse(response);
            } catch ({ message }) {
                if (message !== 'canceled') {
                    console.error('(Client/BannerMapa) Ocurrió un error al solicitar la data:', message);
                    this.cancelMainInformationRequests();
                }
            } finally {
                this.$root.cargando(false);
            }
        },
        /**
         * Cancela los requests para obtener la información principal
         * 
         * @author Óscar
         */
        cancelMainInformationRequests () {
            this.requests?.infoCheckListRequest?.cancel();
            this.requests?.infoDeptosRequest?.cancel();

            Object.assign(this.$data.requests, { infoCheckListRequest: null, infoDeptosRequest: null });
        },
        /**
         * Responsable de la delegación de seteo de los datos obtenidos del servidor.
         * 
         * @param { Array } response
         * 
         * @author
         */
        handleServerResponse (response) {
            const [
                { status: StatusInfoChecklist, data: InfoChecklistData },
                { status: StatusDeptos, data: DataDepartamentos },
            ] = response;

            this.setInfoChecklistData({ StatusInfoChecklist, InfoChecklistData });
            this.setListOfDepartamentos({ StatusDeptos, DataDepartamentos });
        },
        /**
         * Encargado de validar y setear los datos para el checklist
         * 
         * @param { Object } StatusInfoChecklist
         * @param { Object } InfoChecklistData
         * 
         * @author Óscar
         */
        setInfoChecklistData ({ StatusInfoChecklist, InfoChecklistData }) {
            const wrongServerDataCheckList = (! InfoChecklistData?.fuentes?.length || ! InfoChecklistData?.actividadesPrincipales?.length);

            if (StatusInfoChecklist !== 200 || wrongServerDataCheckList) {
                console.error('(InfoCheckList) (Server) No fue posible obtener la data suficiente', { StatusInfoChecklist, InfoChecklistData });
                throw new Error('(InfoCheckList) (Server) No fue posible obtener la data suficiente');
            }

            mutations.addFuentes(InfoChecklistData.fuentes);
            mutations.addActividades(InfoChecklistData.actividadesPrincipales);
            mutations.checkAllFilters();
        },
        /**
         * Encargado de validar y setear los datos del listado de departamentos que utilizará el mapa
         * 
         * @param { Object } StatusDeptos
         * @param { Object } DataDepartamentos
         * 
         * @author Óscar
         */
        setListOfDepartamentos ({ StatusDeptos, DataDepartamentos }) {
            const wronServerDataDepartamentos = ! DataDepartamentos?.departamentos?.length;

            if (StatusDeptos !== 200 || wronServerDataDepartamentos) {
                console.error('(ListadoDepartamentos) (Server) No fue posible obtener la data suficiente', { StatusDeptos, DataDepartamentos });
                throw new Error('ListadoDepartamentos) (Server) No fue posible obtener la data suficiente');
            }

            mutations.addListadoDepartamentos(DataDepartamentos.departamentos);
        },
        /**
         * Encargado de validar y setear los datos de las actividades económicas como la data de los departmentos
         * 
         * @param { Object } StatusDataGeneral
         * @param { Object } DataGeneral
         * 
         * @author Óscar
         */
        setDataGeneral ({ StatusDataGeneral, DataGeneral }, { updateDepto }) {
            const severReturnedEmptyData = (! DataGeneral?.dataActividades?.length || ! DataGeneral?.dataDeptos?.length);

            if (! updateDepto && (StatusDataGeneral !== 200 || severReturnedEmptyData)) {
                if (StatusDataGeneral !== 200) {
                    console.error('(DataGeneral) (Server/Status) Ocurrió un problema al obtener los datos', { StatusDataGeneral, DataGeneral });
                    throw new Error('(DataGeneral) (Server/Status) Ocurrió un problema al obtener los dato');
                }
                
                mutations.updateSinData(true)

                if (severReturnedEmptyData) {
                    console.warn('(DataGeneral) (Server) No fue posible obtener la data suficiente', { StatusDataGeneral, DataGeneral });
                    return;
                }
            }

            mutations.updateSinData(false)
            mutations.changeTotalProcesos(0)
            mutations.changeTotalCuantia(0)
            this.sumaProcesos = 0
            this.sumaDinero = 0
            this.forDataGeneral(DataGeneral.dataActividades)

            mutations.addDataActividades(DataGeneral.dataActividades);

            if (updateDepto) {
                this.updtateASingleDepto(updateDepto, DataGeneral.dataDeptos);
            } else {
                this.updateAllCountry(DataGeneral.dataDeptos);
            }
        },
        /**
         * Actualiza los datos de todos los deptos/provincias del mapa
         * 
         * @param dataDeptos
         * 
         * @author Óscar
         */
        updateAllCountry (dataDeptos) {
            if (dataDeptos?.length) {
                mutations.addDataDepartamentos(dataDeptos);
                return;
            }

            this.clearAllDataDeptos();
        },
        /**
         * Pone en null/vacio los contadores de cada departamento/provincia
         * 
         * @author Óscar
         */
        clearAllDataDeptos () {
            const clearedData = this.copyCurrentDataDeptos.map(depto => {
                return Object.assign(depto, { fuentes: null, total_procesos: null, total_cuantia: null });
            });

            mutations.clearDataDepartamentos();
            mutations.addDataDepartamentos(clearedData);
        },
        /**
         * Actualiza únicamente el deparatemento/provincia
         * 
         * @param { Int } idUpdateDepto
         * @param { Array } depto
         * 
         * @author Óscar
         */
        updtateASingleDepto (idUpdateDepto, depto) {
            mutations.updateASingleDepto(idUpdateDepto, depto);
        },
        /**
         * Petición http con los filtros seleccionados
         * 
         * @author Óscar
         */
        async requestFilteredData ({ fltFuentes = [], fltActividades = [] } = {}, fromTreemap = false) {
            try {
                if (this.requests.filterRequest) {
                    this.cancelFilterRequest();
                }

                const fuentes = fltFuentes?.length > 0 ? fltFuentes : this.filtrosFuentes;
                const actividades = fltActividades?.length > 0 ? fltActividades : this.filtrosActividades;
                
                const params = {
                    departamentos: this.onSelectedDepto?.id_departamento ? [this.onSelectedDepto.id_departamento] : [],
                    fuentes,
                    actividades,
                }

                if (params.fuentes.length == 0) {
                    for (let index = 0; index < store.fuentes.length; index++) {
                        params.fuentes.push(store.fuentes[index].id)
                    }
                }

                this.copyCurrentDataDeptos = this.allDataDeptos;
                
                this.clearInitData(params.departamentos);

                this.$root.cargando();

                const dataGeneralURI = `${this.$root.raiz_virtual}/interactive-map/getDataGeneral`;

                const axiosSource = axios.CancelToken.source();
                const cancelToken = axiosSource.token;

                this.requests.filterRequest = { cancel: axiosSource.cancel };

                const { status: StatusDataGeneral, data: DataGeneral }= await axios.get(dataGeneralURI, {
                    cancelToken,
                    params
                });

                this.setDataGeneral({ StatusDataGeneral, DataGeneral }, { updateDepto: this.onSelectedDepto?.id_departamento });
                
                if (! fromTreemap) {
                    this.$nextTick(() => {
                        this.$emit('onSelectedIndividualActivityFilter', actividades[0]);
                    })
                }
            } catch ({ message }) {
                if (message !== 'canceled') {
                    console.error('(Client/BannerMapa/Filtro) Ocurrió un error al solicitar la data:', message);
                    this.cancelFilterRequest();
                }
            } finally {
                this.$root.cargando(false);
            }
        },
        /**
         * Cancela el request para obtener datos mediante un filtro seleccionado
         * 
         * @author Óscar
         */
        cancelFilterRequest () {
            this.requests?.filterRequest?.cancel();
            this.requests.filterRequest = null;
        },
        /**
         * Limpia la data antes de setear la nueva
         * 
         * @author Óscar
         */
        clearInitData (seletedSingleDepto) {
            mutations.clearDataActividades();
            if (! seletedSingleDepto?.length) {
                mutations.clearDataDepartamentos();
            }
        },
        /**
         * Realiza un solo recorrido for para las funciones de preparacion de dataActividades
         * @param {*} data 
         */
        forDataGeneral(data) {
            for (let index = 0; index < data.length; index++) {
                this.parseoProcesosAndDinero(data[index]);
                this.totalAmount(data[index]);
            }
        },
        /**
         * Se realiza el parseo de la key total de procesos y total de cuantia
         * @author Daniel Sanchez
         */
        parseoProcesosAndDinero(data) {
            if (data.total_procesos !== null && data.total_cuantia !== null) {
                data.total_procesos = parseInt(data.total_procesos)
                data.total_cuantia = parseInt(data.total_cuantia)    
            }
        },
        /**
         * Se realiza la suma total de procesos y de dinero
         * @author Daniel Sanchez
         */
        totalAmount(data) {
            this.sumaProcesos += data.total_procesos
            this.sumaDinero += data.total_cuantia
            mutations.changeTotalProcesos(this.sumaProcesos)
            mutations.changeTotalCuantia(this.getMoneyValue(this.$root.moneda, this.sumaDinero, 0))
        },
        /**
         * Realiza el cambio de treemap de procesos a dinero
         * @author Daniel Sanchez
         */
        changeTreemap() {
            mutations.changeTreemap()
        }
    },
    computed: {
        /**
         * Determina si el filtro por procesos está seleccionado
         * 
         * @author Óscar
         */
        isCantidadProcesos () {
            return store.is_cantidad_procesos;
        },
        /**
         * Filtros de actividades seleccionados
         * 
         * @author Óscar
         */
        filtrosActividades: function () {
            return store.filtrosActividades;
        },
        /**
         * Filtros de fuentes seleccionados
         * 
         * @author Óscar
         */
        filtrosFuentes: function () {
            return store.filtrosFuentes;
        },
        /**
         * Departamento/provincia seleccionado actualmente
         * 
         * @author Óscar
         */
        onSelectedDepto () {
            return store?.deptoSelected;
        },
        /**
         * Data de los departamentos/provincias
         * 
         * @author Óscar
         */
        allDataDeptos () {
            return store.dataDepartamentos;
        },
    },
    watch: {
        /**
         * Ejecuta la obtención de los datos según el filtro establecido
         * 
         * @author Óscar
         */
        filtrosActividades() {
            this.requestFilteredData();
        },
        /**
         * Ejecuta la obtención de los datos según el filtro establecido
         * 
         * @author Óscar
         */
        filtrosFuentes () {
            this.requestFilteredData();
        },
        /**
         * Ejecuta la obtención de los datos según el departamento/provincia seleccionado
         * 
         * @author Óscar
         */
        onSelectedDepto () {
            this.requestFilteredData();
        }
    }
}
</script>

<style lang="scss">
.mapp__container{
    margin-top: 68px;
    &-texto {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 38px;
    }
    &-titulo {
        text-align: center;
        font-size: 1.57rem;
        font-weight: bold;
        font-family: Poppins;
        color: #959595;
        margin-bottom: 9px;
        &--modifier{
            color: #00A1C9;
        }
    }
    &-parrafo {
        width: 100%;
        max-width: 990px;
        font-size: 1.3rem;
        font-weight: normal;
        font-family: Roboto;
        color: #686868;
    }
    &-contenedor {
        background-color: rgba(#DADADA, 0.223);
        padding: 15px;
    }
    &-listadoacti {
        background: white;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 10px;
    }
    &-checklist, &-treemap {
        background-color: white;
        box-shadow: 0 0 10px 5px rgb(177 169 169 / 11%);
    }
}
</style>